import styled from 'styled-components'

export const BoxDefault = styled.main`
  background: var(--background-table);
  border: 1px solid var(--border-color-table);
  box-sizing: border-box;
  border-radius: 13px;
  padding: 24px;
  min-width: min-content;
`
